// import React, { Component } from 'react';
// import routes from './routes';
// import { BrowserRouter, Navigate } from "react-router-dom";
// import { Provider } from 'react-redux';
// import { getDataOnLocal } from './utils/AppHelper';
// import { getAccessTokenData } from './utils/AxoisHelper';



// class Root extends Component {
//   store  = this.props
//   loginData = getDataOnLocal('user_data')
//   accessTokenData = getAccessTokenData();
//   currentURL = window.location.href.split("/");
//   componentDidMount() {

//     if (this.loginData !== null && this.accessTokenData !== null && this.accessTokenData.message !=='TOKEN IS EXPIRED.') {
//       routes(this.store.dispatch)
//     }
//     if (this.currentURL[3] == 'sign-up') {
//       if (this.currentURL[3] !== 'sign-up') {
//         //location.replace("/sign-up")

//       } else {
//         return;
//       }
//     }
//     else {
//       if (this.currentURL[4] && this.currentURL[4] === 'verify-mail') {
//         return;
//       }
//       if (this.currentURL[3] !== '') {
//         if(this.loginData === null && this.accessTokenData === null){
//           //location.replace("/")
//         }
//       } 
//     }
//   }
//   render() {
//     const { store } = this.props;
//       return (
//       <Provider store={store}>
//         <BrowserRouter>
//             {/* {routes(store.dispatch)} */}
//             {routes(store.dispatch)}
//         </BrowserRouter>
//       </Provider>
//     );
//   }
// }

// export default Root;


import React, { Component } from 'react';
import { BrowserRouter } from "react-router-dom";
import { Provider } from 'react-redux';
import { getDataOnLocal } from './utils/AppHelper';
import { getAccessTokenData } from './utils/AxoisHelper';
import RenderedRoutes from './routes';

class Root extends Component {
  store  = this.props
  loginData = getDataOnLocal('user_data')
  accessTokenData = getAccessTokenData();
  currentURL = window.location.href.split("/");



  render() {
    const { store } = this.props;
    return (
      <Provider store={store}>
        <BrowserRouter>
          <RenderedRoutes /> 
        </BrowserRouter>
      </Provider>
    );
  }
}

export default Root;

